export class Registration {
    id: number;
    work_project_id: number;
    leave_id: number;
    from: Date;
    till: Date;
    starttime: string;
    endtime: string;
    user_id: number;
    comments: any[] = [];
    approved_by?: number;
    approved_at?: Date;
    disapproved_at?: Date;
}

export class RegistrationV2 {
    id: number;
    work_project_id: number;
    user_id: number;
    starttime: string;
    endtime: string;
    parent_work_project_id: number;
    company_id: number;
    working_project: number;
    name: string;
    azure_id: string;
    budget: string;
    budget_fixed?: null | boolean;
    created_at: string;
    updated_at: string;
    approved_by?: number;
    approved_at?: Date;
    disapproved_at?: Date;
}
